import { fetchDetailData } from '../api';
import { PUBLIC_JOB_DETAIL_URL } from '../const';
import { useDataQuery } from '@packages/dataQuery';
import { PublicJobDetailResponseData } from '../types';
import { RouteIdParamOnly } from '../../../../types';
import { setDocumentTitle } from '../../../page/utils';
import { useParams } from '@packages/router-dom';

const DEFAULT_DATA: PublicJobDetailResponseData = {
	title: '',
	ageFormatted: null,
	alertSubscription: null,
	applyUrl: '',
	description: '',
	employer: null,
	employmentTypeName: null,
	experienceFormattedName: null,
	formattedAddress: '',
	formattedPeriod: '',
	id: -1,
	industryFormattedName: null,
	isExpired: false,
	isTop: false,
	jobCategoryFormattedName: '',
	jobContact: null,
	jobEducationLevelName: null,
	jobTypeName: null,
	openGraphTags: [],
	salaryFormatted: null,
	similarJobs: null,
	skills: null,
	tags: null,
	workingHoursPerWeekFormatted: null,
	page: { title: '' },
};

export function usePublicJobDetailDataQuery() {
	const { id } = useParams<RouteIdParamOnly>();

	const dataQuery = useDataQuery([PUBLIC_JOB_DETAIL_URL, id], () => fetchDetailData(id), {
		onSuccess: (data) => {
			setDocumentTitle(data.page.title);
		},
	});

	return {
		...dataQuery,
		data: dataQuery.data || DEFAULT_DATA,
	};
}
